import { render, staticRenderFns } from "./candy-planets-video.vue?vue&type=template&id=bc8892c2&functional=true&"
import script from "./candy-planets-video.vue?vue&type=script&lang=js&"
export * from "./candy-planets-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports